var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eye-closed"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6183 13.8379C16.8972 13.6346 16.9586 13.2437 16.7552 12.9647L14.6926 10.1345C14.4893 9.85557 14.0983 9.79425 13.8194 9.99755C13.5404 10.2009 13.4791 10.5918 13.6824 10.8708L15.7451 13.701C15.9484 13.9799 16.3393 14.0412 16.6183 13.8379Z",
    fill: "#656579"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0002 15.2078C10.3453 15.2078 10.6252 14.928 10.6252 14.5828V11.6662C10.6252 11.321 10.3453 11.0412 10.0002 11.0412C9.65498 11.0412 9.37515 11.321 9.37515 11.6662V14.5828C9.37515 14.928 9.65498 15.2078 10.0002 15.2078Z",
    fill: "#656579"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.38204 13.8379C3.66099 14.0412 4.05194 13.9799 4.25524 13.701L6.3127 10.8779C6.51601 10.599 6.45468 10.208 6.17573 10.0047C5.89678 9.80142 5.50583 9.86274 5.30252 10.1417L3.24506 12.9647C3.04176 13.2437 3.10309 13.6346 3.38204 13.8379Z",
    fill: "#656579"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9302 6.40969C14.1513 12.585 5.84899 12.585 3.07011 6.40969C2.92846 6.09492 2.55845 5.95457 2.24368 6.09622C1.9289 6.23787 1.78855 6.60787 1.9302 6.92265C5.15132 14.0807 14.849 14.0807 18.0701 6.92265C18.2118 6.60787 18.0714 6.23787 17.7566 6.09622C17.4419 5.95457 17.0719 6.09492 16.9302 6.40969Z",
    fill: "#656579"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClosed);
export default __webpack_public_path__ + "static/media/eye_closed.0fcdf237189fd2e278038a2a959262cc.svg";
export { ForwardRef as ReactComponent };